import Item from '../Item';
import useStyles from './styles';
import { Size, SizesPostListType } from '../../types';

type Props = {
  SizesList: SizesPostListType[] | Size[];
};

const CategoryItem = ({ SizesList }: Props) => {
  const classes = useStyles();

  // Проверяем, является ли первый элемент `SizesPostListType`
  const sizesFilter =
    Array.isArray(SizesList) && 'sizes' in SizesList[0]
      ? (SizesList as SizesPostListType[]).flatMap(item => item.sizes)
      : (SizesList as Size[]);

  return (
    <div className={classes.root}>
      <div className={classes.sizeItemWrapper}>
        {sizesFilter.map((item, itemIndex) => (
          <Item key={`${itemIndex}szie`} sizeItem={item} data-testid={itemIndex} />
        ))}
      </div>
    </div>
  );
};

export default CategoryItem;
